export const UPDATE_RV_ENV = "UPDATE_RV_ENV";
export const UPDATE_RV_PROPERTIES = "UPDATE_RV_PROPERTIES";
export const UPDATE_RV_SEARCH_OPTIONS = "UPDATE_RV_SEARCH_OPTIONS";
export const RV_REMOVE_PROPERTY = "RV_REMOVE_PROPERTY";
export const RV_UPDATE_PROPERTY = "RV_UPDATE_PROPERTY";
export const RV_UPDATE_REASON = "RV_UPDATE_REASON";
export const RV_UPDATE_DOCS = "RV_UPDATE_DOCS";
export const RV_RESET = "RV_RESET";